import FormInputTag from './FormInputTag';
export default FormInputTag;
